import { Component, OnChanges, SimpleChanges, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { faGift } from '@fortawesome/free-solid-svg-icons/faGift';
import { faShoppingBasket } from '@fortawesome/free-solid-svg-icons/faShoppingBasket';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getCurrencySymbol, NgClass, CurrencyPipe } from '@angular/common';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { combineLatest, of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { HttpService } from 'src/app/services/http.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SessionStorage } from 'src/app/services/session-storage.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgxMaskDirective } from 'ngx-mask';
import { FontAwesomeModule, IconDefinition } from '@fortawesome/angular-fontawesome';
import { AudioComponent } from "../audio/audio.component";
import { VideoRecorderComponent } from '../video-recorder/video-recorder.component';

interface Voucher {
     voucherpreset_id?: string, 
     amount: number, 
     qty: number, 
     image?: string, 
     title?: string, 
     hideprice?:boolean, 
     wrap_option_id?:number,
     message?: string,
     product_id?: string,
}

interface BasketModalElement extends HTMLElement {
    setCart: any[];
    addToCart: any[];
}


@Component({
    templateUrl: './geronigo-vouchers.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, FormsModule, NgxMaskDirective, ReactiveFormsModule, FontAwesomeModule, CurrencyPipe, TranslatePipe, AudioComponent, VideoRecorderComponent]
})
export class GeronigoVouchersComponent implements OnInit, OnChanges, OnDestroy {
    @Input() brandId: string;
    @Input() venueId: string;
    @Input() saleId: string;
    @Input() guestKey: string;
    @Input() cart = '0';
    @Input() curr: string;
    @Input() opened: boolean = false;
    @Input() promocode: string;


    @Input() submitToCartElement: string = '';
    @Input() fbad: string;
    @Input() gclid: string;
    @Input() gbraid: string;
    @Input() wbraid: string;
    @Input() bingad: string;
    @Input() affiliateId: string;
    @Input() adId: string;
    @Input() splitTest: string;
    @Input() test: string;
    @Input() theme: string;
    @Input() price: string;
    
    @Output() initialised: EventEmitter<void> = new EventEmitter();

    public faGiftCard: IconDefinition = faGift;
    public faShoppingBasket: IconDefinition = faShoppingBasket;

    public viewBasket = [];

    public loading = true;
    public setCartLoader = false;
    public amount = new UntypedFormControl(25, Validators.required);
    public company: any = null;
    public directories: any = {};
    public presets: any[] = [];
    public hint = '';

    public bindHtml = '<b>meh</b><script language="javascript">console.log("a");</script>';

    private onVoucherDeleted = this.deleteVoucher.bind(this);
    private onVouchersUpdated = this.syncBasketFromStorage.bind(this);
    private _voucherConfig: any = null;
    private _images: string[] = [];
    private lastExternalAddSignature = '';
    private lastExternalAddAt = 0;

    private getExternalAddSignature(data: Voucher): string {
        return JSON.stringify({
            voucherpreset_id: data?.voucherpreset_id || null,
            amount: +(data?.amount || 0),
            qty: +(data?.qty || 1),
            title: data?.title || '',
            message: data?.message || '',
            product_id: data?.product_id || '',
            image: data?.image || '',
            hideprice: !!data?.hideprice,
        });
    }

    public sale: any;

    public inited : boolean = false;;

    public modalDisplayed = false;

    constructor(
        private http: HttpService,
        private payment: PaymentService,
        private cd: ChangeDetectorRef,
        private translate: TranslateService,
        private sessionStorage: SessionStorage,
        private sanitized: DomSanitizer
    ) {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        window['dataLayer'] = window['dataLayer'] || [];

        this.translate.setFallbackLang('en');
    }

    ngOnInit() {
        let test = new URLSearchParams(window.location.search).get('test');
            if(test!==undefined && test !== null){
            this.test = +test+'';
            if(test === 'true') this.test = '1';
            if(this.test === 'NaN' || this.test === '0') this.test = '';
             if(this.test) this.http.mode = 'test';
        }

        let venueId = new URLSearchParams(window.location.search).get('venue_id');
        if(+venueId) this.venueId = venueId;
        
        let brandId = new URLSearchParams(window.location.search).get('brand_id');
        if(+brandId) this.brandId = brandId;

        let saleId = new URLSearchParams(window.location.search).get('sale_id') || new URLSearchParams(window.location.search).get('id');
        if(+saleId) this.saleId = saleId;


        let guestKey = new URLSearchParams(window.location.search).get('guest_key');
        if(guestKey) this.guestKey = guestKey;

        //console.log(saleId, guestKey);

        this.syncBasketFromStorage();

        //this.amount.disable();

        if (this.apiUrl && this.appKey && this.apiKey) this.getData();

        window.addEventListener('voucherDeleted', this.onVoucherDeleted);
        window.addEventListener('vouchersUpdated', this.onVouchersUpdated);

        if(this.opened){
            //this.addToCart ={'qty':1, 'title':'test', 'amount':10};
            this.showBasket();
        }

        //initialise params
        this.http.view_params = {
            fbad: this.fbad,
            gclid:this.gclid,
            bingad:this.bingad,
            affiliateId:this.affiliateId,
            adId:this.adId,
            splitTest:this.splitTest,
            test:this.test,
            brandId: this.brandId,
            venueId: this.venueId,
            saleId: this.saleId,
            cart: this.cart,
            curr: this.curr,
            opened: this.opened,
            //guestKey: this.guestKey
            promocode: this.promocode
        }

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.lang && changes.lang.currentValue) this.translate.use(changes.lang.currentValue);
        /*if(changes.saleId){
            this.getData(true);
        }*/
       // Keep tracking params in sync when host attributes/inputs change.
        if(changes.fbad || changes.gclid || changes.bingad || changes.affiliateId || changes.adId || changes.test || changes.brandId || changes.venueId || changes.saleId || changes.cart || changes.curr || changes.promocode){
            ['fbad','gclid','gbraid','wbraid','bingad','affiliateId','adId','test','brandId','venueId','saleId','cart','curr','promocode'].forEach(param=>{
                if(changes[param]){
                    this.http.view_params[param] = changes[param].currentValue;
                }
            });

            if(this.http.view_params?.affiliateId && !this.http.view_params?.affiliate_id){
                this.http.view_params.affiliate_id = this.http.view_params.affiliateId;
            }
            if(this.http.view_params?.affiliate_id && !this.http.view_params?.affiliateId){
                this.http.view_params.affiliateId = this.http.view_params.affiliate_id;
            }
            if(this.http.view_params?.adId && !this.http.view_params?.affiliate_id){
                this.http.view_params.affiliate_id = this.http.view_params.adId;
                this.http.view_params.affiliateId = this.http.view_params.adId;
            }
        }
    }

    ngOnDestroy() {
        window.removeEventListener('voucherDeleted', this.onVoucherDeleted);
        window.removeEventListener('vouchersUpdated', this.onVouchersUpdated);
    }

    @Input()
    set voucherConfig(values: any) { this._voucherConfig = JSON.parse(values); }
    get voucherConfig() { return this._voucherConfig };

    @Input()
    set images(values: any) { this._images = JSON.parse(values); }
    get images() { return this._images };

    @Input()
    set apiUrl(url: string) { this.http.baseURL = url; this.http.configureSharedApi(); }
    get apiUrl(): string { return this.http.baseURL; }

    @Input()
    set appKey(val: string) { this.http.appKey = val; this.http.configureSharedApi(); }
    get appKey(): string { return this.http.appKey; }

    @Input()
    set apiKey(val: string) { this.http.apiKey = val; this.http.configureSharedApi(); }
    get apiKey(): string { return this.http.apiKey; }

    @Input()
    set share(val: boolean|string) { this.http.shared_storage = this.parseBooleanAttribute(val, true); }
    get share(): boolean { return this.http.shared_storage; }

    @Input()
    set mode(val: 'test'|'live') { this.http.mode = val; }
    get mode(): 'test'|'live' { return this.http.mode; }

    @Input()
    set lang(val: string) { this.http.lang = val; }
    get lang(): string { return this.http.lang; }

    @Input()
    set openCart(cart: boolean) {
        this.showBasket();
    }

    @Input() 
        set debug(val : boolean) {
            this.payment.debug = val;
        }

    @Input()
    set setCurrency(curr: string) {
        if(!this.sale){
            this.curr = curr;
            if (!this.company) return;

            this.company.currency = this.curr;
            this.sessionStorage.setItem('company', JSON.stringify(this.company));
            this.payment.currency = this.company.currency;

            this.syncBasketFromStorage();

            document.querySelector('basket-modal')?.remove?.();
            this.showBasket();

        }

        

        
    }


    @Input()
    set addToCart(data: Voucher) {
        if (!data) return;

        if(!this.directories || !this.company){
            //still loading
            setTimeout(()=>this.addToCart = data, 300);
            return;
        }

        const signature = this.getExternalAddSignature(data);
        const now = Date.now();
        if (signature === this.lastExternalAddSignature && now - this.lastExternalAddAt < 2000) {
            return;
        }
        this.lastExternalAddSignature = signature;
        this.lastExternalAddAt = now;

        data.amount = +data.amount;
        data.qty = +data.qty;

        /*if(!this.inited){
            setTimeout(()=>this.addToCart = data, 300);
            return;
        }*/


        let preset = undefined;
        if (data?.voucherpreset_id) {
            const item = (this.presets??[]).find(val => +val.voucherpreset_id === +data.voucherpreset_id);

            if (!item) return;

            this.selectPreset(item, +data.qty || 1, true);
            return;
        }

        const item = (this.directories.wrap_options??[]).find(val => val.tag === 'email');

        let voucher_obj :any = {
            value: +data.amount || +this.amount.value,
            wrap_option_id: item?.wrap_option_id,
            mail_service_id: '1',
            preset: preset,
            name: null,
            message: data?.message || '',
            title:data.title || null,
            delivery_name: '',
            address_1: '',
            address_2: '',
            town:'',
            zip:'',
            tag: item?.tag || 'email',
            image: data?.image,
            design: data?.image || this.company?.image || this.company?.images?.[0]?.full_url,
            audio_video: item?.audio_video,
            product_id: data?.product_id || null,
        }

        if(data?.hideprice){
            voucher_obj.hideprice = true;
        }

        let datas = [...Array(data.qty || 1).fill(voucher_obj)];

        this.viewBasket = [
            ...datas,
            ...this.viewBasket
        ];

        this.persistBasket();
        
        this.addToModal(true, datas);
     }

     set setCart(vouchers: {[key:string]:any}[]) {
        if (!vouchers) return;
        this.viewBasket = [
            ...vouchers
        ];

        this.persistBasket();
        this.showBasket();
     }

     public addToModal(retries_allowed : boolean = true, data: any){
        const modals = document.getElementsByTagName('basket-modal');
        if(modals.length > 0){
            // Connected modals hydrate synchronously; append only the new vouchers.
            (modals[0] as BasketModalElement).addToCart = data;
        }else{
            if(retries_allowed){
                // Open the modal. persistBasket() has already written to session storage,
                // so the modal's ngOnInit will hydrate the full cart from storage.
                this.showBasket();
                this.setCartLoader = true;
            }
        }
    }

    public get currency(): string {
        return getCurrencySymbol(this.company.currency || 'USD', 'narrow', 'en-GB');
    }

    public get paymentsSetup(): boolean {
        return this.payment.initialized;
    }

    public openModal(amount?: number, qty = 1, show = true, design = null, title = null): void {
        if(!+amount){
            amount = this.amount.getRawValue();
        }
        let vouch :Voucher = {amount, qty, image:design, title};
        if(this.submitToCartElement){
            if(document.getElementsByTagName(this.submitToCartElement).length > 0){
             let elem :any = document.getElementsByTagName(this.submitToCartElement)[0];

             elem.addToCart = vouch;
            }else{
            this.addToCart = vouch; //fallback
        }
        }else{
            this.addToCart = vouch;
        }
    }


    public selectPreset(item: any, qty = 1, show = true): void {
        const wrapOption = this.directories.wrap_options.find(val => val.tag === 'email');
        this.viewBasket = [
            ...Array(qty).fill({
                value: +item.price,
                wrap_option_id: wrapOption.wrap_option_id,
                tag: wrapOption.tag,
                image: item.image_url,
                preset: item,
                mail_service_id: '1',
                name: '',
                message: '',
                address: ''
            }),
            ...this.viewBasket
        ];

        this.persistBasket();

        this.showBasket(qty, show);
    }

    public showBasket(qty = 1, message = false, retry=true) {
        if(!this.inited || !this.paymentsSetup){
            if(retry){
                setTimeout(()=>this.showBasket(qty, message),500);
            }
            return;
        }
        let exists = false;
        let elem = document.createElement('basket-modal') as any;
        if(document.getElementsByTagName('basket-modal').length > 0){
             exists = true;
             elem = document.getElementsByTagName('basket-modal')[0];
        }

        elem.brandId = this.brandId;
        elem.promocode = this.promocode;
        elem.qty = qty;
        elem.fbad = this.fbad;
        elem.gclid = this.gclid;
        elem.gbraid = this.gbraid;
        elem.wbraid = this.wbraid;
        elem.bingad = this.bingad;
        elem.affiliateId = this.affiliateId;
        elem.adId = this.adId;
        elem.splitTest = this.splitTest;
        elem.test = this.test;

        if(this.sale) elem.sale = this.sale;
        elem.setCart = this.viewBasket;

        if (+this.cart) elem.message = message;

        if(!exists){
            document.body.appendChild(elem);
        }

        setTimeout(()=>this.modalDisplayed = true,0);
        this.checkModal();
        return elem;
    }

    public checkModal(){
        if(document.getElementsByTagName('basket-modal').length  == 0){
            setTimeout(()=>this.modalDisplayed = false,0);
            return; 
        }

        setTimeout(()=>this.checkModal(),500);
    }

    public editVoucherValue(value: number): void {
        let amount = this.amount.value;
        if(this.curr == 'ZAR' && this.company?.company_id == '2'){
            value = value*20;
            amount = Math.round(amount/100)*100;
        }

        const val = amount + value;

        if (val <= this.company.voucher_config.max && val >= this.company.voucher_config.min) this.amount.setValue(val);

        this.checkHint();
    }

    private getData(partial: boolean = false): void {

        let currencies = ['GBP','EUR','USD','AUD','NZD','ZAR'];
        if(this.curr && !currencies.find(c=> c == this.curr)){
            this.curr = 'GBP';
        }
        const requiredDirectories = ['pay_profile','wrap_options','sale_types','mail_services','texts','activities'];

        this.http.getPublicKey().pipe(
            switchMap(() => {
                const missingDirectories = partial ? [] : this.http.getMissingDirectories(requiredDirectories);

                return combineLatest([
                    partial || missingDirectories.length === 0 ?of(null):this.http.get('/directories', {
                        params: {
                            directories: missingDirectories.join(',')
                        }
                    }),
                    partial ?of(null):this.http.get('/companies', {
                        params: { company_id: 'self' },
                        headers: { 'X-ATTRIBUTES': 'country,currency,rules,voucher_config,company_id,voucher_valid' }
                    }),
                    partial ?of(null):this.http.get('/images', {
                        params: { company_id: 'self', type: 'logo' }
                    }),
                    partial ?of(null):this.http.get('/voucherpresets', {
                        params: { company_id: 'self', limit: '500' }
                    }),
                    !this.saleId?of(null):this.http.get('/sales', {
                        headers:{'X-API-KEY':this.guestKey},
                        params: { sale_id: this.saleId }
                    }),
                    !this.brandId ?of(null):this.http.get('/brands', {
                        params: { company_id: 'self', brand_id:this.brandId}
                    }),

                ]);
            }),
            tap(([dirRes, compRes, logoRes, presetsRes, saleRes, brandRes]) => {
                let logos = logoRes.body?.images || [];
                if(logos.length > 1){
                    logos = logos.filter(it=>it.brand_id == this.brandId);
                    if(logos.length == 0) logos = logoRes.body?.images || [];
                }
                let logo = logos[0];



                this.directories = this.http.getStoredDirectories();
                if(dirRes?.body){
                    this.directories = this.http.storeDirectories(dirRes.body);
                }
                
                if (presetsRes?.body) this.presets = presetsRes.body?.voucherpresets || [];
                this.presets.forEach(preset=>preset.safe_desc = this.sanitized.bypassSecurityTrustHtml(preset.desc))


                let company: any = {};
                if(compRes && compRes.body?.companies){
                    company = compRes.body?.companies[0];
                }else{
                    company = this.company;
                }
                this.http.view_params['company_id'] = company?.company_id;

                if(brandRes?.body?.brands && brandRes?.body?.brands?.[0].logo){
                    logo = {filename:'https://rezbot.com/images/logos/'+brandRes?.body?.brands[0].logo};
                }
                let logo_url = logo?.filename;

                if(logo_url && logo_url.indexOf('://') < 0){
                    logo_url = `${this.directories.resources.images_path}/images/rezbot/*by200/${logo?.filename}`
                }

                this.company = {
                    ...company,
                    currency: this.curr || company.currency,
                    logo: logo_url
                };
                
                this.company.voucher_config = this.voucherConfig || this.company.voucher_config;
                
                this.sessionStorage.setItem('directories', JSON.stringify(this.directories));

                this.sessionStorage.setItem('params', JSON.stringify({fbad: this.fbad, gclid:this.gclid, gbraid:this.gbraid, wbraid:this.wbraid, bingad:this.bingad, affiliateId:this.affiliateId, adId:this.adId, test:this.test}));
                this.sessionStorage.setItem('company', JSON.stringify(this.company)); //first store

                if(saleRes?.body){
                    this.sale = saleRes.body.sales[0];
                    this.curr = this.sale.currency;
                    this.company.currency = this.curr;

                    this.sessionStorage.removeItem('vouchers');
                    try{
                        localStorage.removeItem('vouchers');
                    }catch{

                    }

                    this.setCart = this.sale.vouchers;
                    if(this.sale.vouchers[0]?.brand_id){
                        this.brandId = this.sale.vouchers[0].brand_id+'';
                        this.http.get('/brands', {
                            params: { company_id: 'self', brand_id:this.brandId}
                        })  .subscribe(brandRes=>{
                            // Process brandRes here
                            logo = logos[0];
                            if(brandRes?.body?.brands && brandRes?.body?.brands?.[0].logo){
                                logo = {filename:'https://rezbot.com/images/logos/'+brandRes?.body?.brands[0].logo};
                            }
                            let logo_url = logo?.filename;

                            if(logo_url && logo_url.indexOf('://') < 0){
                                logo_url = `${this.directories.resources.images_path}/images/rezbot/*by200/${logo?.filename}`
                            }

                            this.company = {
                                ...company,
                                currency: this.curr || company.currency,
                                logo: logo_url
                            };
                            //this.sessionStorage.setItem('company', JSON.stringify(this.company)); //store again
                        });
                    }

                    //need to get the brand again

                    //this.sale.vouchers.forEach(it=>this.addToCart =it)

                    //setTimeout(()=>this.showBasket(0,false),200);
                }
                
                let val = this.company?.voucher_config?.displayValue;
                if(this.price){
                    if(this.company.voucher_config?.hints?.[0]?.val){
                        this.company.voucher_config.hints[0].val = +this.price;
                    }
                    val = +this.price;
                }
                this.amount.setValue(val);
            	this.checkHint();
            }),
            switchMap(() => {
                //return this.http.get('/images', { params: { caption: `wrap_option:${this.company.company_id}:email` } });
                return this.http.get('/images', { params: { type:'voucher',company_id:'self', limit:'200' } });
            }),
            finalize(() => this.loading = false)
        )
        .subscribe(res => {

            if (this.images?.length) {


                if(this.images?.[0]?.full_url === undefined){
                    this.company.image = this.images?.[0];
                    this.company.images = this.images.map(img=>({full_url:img}));    
                }else{
                    this.company.image = this.images?.[0]?.full_url;
                    this.company.images = this.images;
                }
            } else {
                const img = (res.body?.images||[]).find(item => +item.def === 1);

                //this.company.image = img ? `${this.directories.resources.images_path}/images/rezbot/600by450/${img.filename}` : null;
                //this.company.image = img ? `${this.directories.resources.images_path}/images/rezbot/300by250/${img.filename}` : null;
                let filtered = res.body?.images || [];
                filtered = filtered.filter(item=>(!this.brandId || this.brandId != '0') && this.brandId == item.brand_id);

                if(filtered.length == 0){
                    filtered = res.body?.images||[];
                }
                if(this.venueId){
                    let old_filtered = filtered;
                    filtered = filtered.filter(it=>!+it.venue_id || it.venue_id == this.venueId);
                    if(filtered.length == 0){
                        filtered = old_filtered;
                    }
                }

                this.company.images = filtered.map(item => ({...item,
                     full_url:`${this.directories.resources.images_path}/images/rezbot/600by450/${item?.filename}`
                }));
            }

            this.sessionStorage.setItem('company', JSON.stringify(this.company));

            this.payment.currency = this.company.currency;
            if(!this.inited){
                let options:{[key:string]:any} = {};
                if(this.brandId == '17' && this.company.currency == 'GBP'){
                    options.paylater = true;
                }else{
                    options.paylater = false;
                }
                this.payment.init(null, this.directories.pay_profile, options);
            }

            this.cd.detectChanges();
            this.initialised.emit();
            setTimeout(()=>{
                this.inited = true
            });
        });
    }

    private deleteVoucher(): void {
        setTimeout(() => this.syncBasketFromStorage(), 0);
    }

    private syncBasketFromStorage(): void {
        this.viewBasket = JSON.parse(this.sessionStorage.getItem('vouchers')) || [];
        try {
            const persisted = localStorage.getItem('vouchers');
            if (persisted) {
                this.viewBasket = JSON.parse(persisted) || this.viewBasket;
            }
        } catch {
            // Ignore localStorage access errors (e.g. restricted mode).
        }
        this.cd.detectChanges();
    }

    private persistBasket(): void {
        this.sessionStorage.setItem('vouchers', JSON.stringify(this.viewBasket));
        try {
            localStorage.setItem('vouchers', JSON.stringify(this.viewBasket));
        } catch {
            // Ignore localStorage access errors (e.g. restricted mode).
        }

        window.dispatchEvent(new Event('vouchersUpdated'));
    }

    private checkHint(): void {
        if (!this.company.voucher_config || !this.company.voucher_config.hints) return;

        const hint = this.company.voucher_config.hints.find(item => item.val === this.amount.value);

        if (hint) this.hint = hint.text;
        else this.hint = '';
    }

    private parseBooleanAttribute(value: boolean|string, defaultValue: boolean): boolean {
        if (value === undefined || value === null || value === '') return defaultValue;
        if (typeof value === 'boolean') return value;

        return !['false','0','no','off'].includes(value.toLowerCase());
    }
}
